const validEmailRegExp = new RegExp(/^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6})*$/);

export const isValidEmail = (email: string) => {
    return validEmailRegExp.test(email);
};
